import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createCompanyActions } from './actions';
import { CompanyActions, CompanyState } from './types';

export const useCompanyStore = create<CompanyState & CompanyActions>()(
    immer((set, get, store) => ({
        selectedCompany: null,
        loadingCompany: false,
        error: undefined,
        ...createCompanyActions(set, get, store),
    })),
);
